import React from 'react'
import './KabaddiCommentary.scss'

export default function KabaddiCommentary({ teams, commentary }) {
    if (! commentary) {
        return (
            <div className="commentaries">
                Innings yet to start
            </div>
        )
    }

    const { commentaries: commentaryData } = commentary;

    let { inns1 } = commentaryData;

    let commentaries = [...inns1]

    // Most recent commentary is displayed first
    commentaries.reverse();

    return (
        <div className="commentaries">
            {commentaries.map(({ball, commentary}, index) => {
                return (
                    <div className="commentary" key={index}>
                        <div className="commentary-item" key={index}>
                            <span className="ball">{ball}</span>
                            {commentary}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
